var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomisableProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "customisable-product_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.11 96.9"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M41.99 10.82h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M-946.01-667.18h1366v2113h-1366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M7.46 3.45h51.19c.46 0 .83 1.26.83 2.82v14.11c0 1.55-.37 2.82-.83 2.82H7.46c-.46 0-.83-1.27-.83-2.82V6.27c0-1.56.37-2.82.83-2.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M-107.36-370.62h226.32V821.57h-226.32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M41.99 36.83h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M-946.01-641.18h1366v2113h-1366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M7.46 29.45h51.19c.46 0 .83 1.26.83 2.82v14.11c0 1.55-.37 2.82-.83 2.82H7.46c-.46 0-.83-1.27-.83-2.82V32.27c0-1.56.37-2.82.83-2.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M-107.36-344.62h226.32V847.57h-226.32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M101.99 10.82h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M-886.01-667.18h1366v2113h-1366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M67.46 3.45h51.19c.46 0 .83 1.26.83 2.82v14.11c0 1.55-.37 2.82-.83 2.82H67.46c-.46 0-.83-1.27-.83-2.82V6.27c0-1.56.37-2.82.83-2.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M-47.36-370.62h226.32V821.57H-47.36z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M101.99 36.83h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M-886.01-641.18h1366v2113h-1366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M67.46 29.45h51.19c.46 0 .83 1.26.83 2.82v14.11c0 1.55-.37 2.82-.83 2.82H67.46c-.46 0-.83-1.27-.83-2.82V32.27c0-1.56.37-2.82.83-2.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M-47.36-344.62h226.32V847.57H-47.36z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M161.99 10.82h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M-826.01-667.18h1366v2113h-1366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M127.46 3.45h51.19c.46 0 .83 1.26.83 2.82v14.11c0 1.55-.37 2.82-.83 2.82h-51.19c-.46 0-.83-1.27-.83-2.82V6.27c0-1.56.37-2.82.83-2.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M12.64-370.62h226.32V821.57H12.64z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M161.99 36.83h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M-826.01-641.18h1366v2113h-1366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M127.46 29.45h51.19c.46 0 .83 1.26.83 2.82v14.11c0 1.55-.37 2.82-.83 2.82h-51.19c-.46 0-.83-1.27-.83-2.82V32.27c0-1.56.37-2.82.83-2.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "customisable-product_svg__clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customisable-product_svg__cls-1",
    d: "M12.64-344.62h226.32V847.57H12.64z"
  })), /*#__PURE__*/React.createElement("style", null, ".customisable-product_svg__cls-1,.customisable-product_svg__cls-11,.customisable-product_svg__cls-32{fill:none}.customisable-product_svg__cls-2,.customisable-product_svg__cls-33{isolation:isolate}.customisable-product_svg__cls-33{font-size:9px}.customisable-product_svg__cls-8{fill:#323232}.customisable-product_svg__cls-11{stroke:#d8d8d8;stroke-width:2px}.customisable-product_svg__cls-32{stroke:#333}.customisable-product_svg__cls-33{fill:#333;font-family:Lato-Regular,Lato}"))), /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_68120",
    "data-name": "Group 68120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_61640",
    "data-name": "Group 61640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_61628",
    "data-name": "Group 61628"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(28.54 86.45)",
    style: {
      isolation: "isolate"
    },
    fontFamily: "Lato-Bold,Lato",
    fontWeight: 700,
    fill: "#0e5a7b",
    fontSize: 9,
    id: "customisable-product_svg__Add_Item",
    "data-name": "Add Item"
  }, "Add Item"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(14.63 86.45)",
    style: {
      isolation: "isolate"
    },
    fontFamily: "FontAwesome5Free-Solid,\"Font Awesome 5 Free\"",
    fill: "#0e5a7b",
    fontSize: 9,
    id: "customisable-product_svg___"
  }, "\uF055")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Rectangle_28807",
    "data-name": "Rectangle 28807"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "customisable-product_svg__cls-1",
    x: 6.63,
    y: 71.45,
    width: 67,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.13,
    y: 71.95,
    width: 66,
    height: 21,
    rx: 3.5,
    stroke: "#0e5a7b",
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_68087",
    "data-name": "Group 68087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_68051",
    "data-name": "Group 68051"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-2)",
    id: "customisable-product_svg__Group_46939",
    "data-name": "Group 46939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_46938",
    "data-name": "Group 46938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Path_56194",
    "data-name": "Path 56194",
    className: "customisable-product_svg__cls-8",
    d: "M37 5.82h19v15H37z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-4)",
    id: "customisable-product_svg__Group_47139",
    "data-name": "Group 47139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_47138",
    "data-name": "Group 47138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_47137",
    "data-name": "Group 47137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Path_56414",
    "data-name": "Path 56414",
    className: "customisable-product_svg__cls-11",
    d: "M7.46 3.45h51.19c.46 0 .83 1.26.83 2.82v14.11c0 1.55-.37 2.82-.83 2.82H7.46c-.46 0-.83-1.26-.83-2.82V6.27c0-1.56.37-2.82.83-2.82z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_68054",
    "data-name": "Group 68054"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-6)",
    id: "customisable-product_svg__Group_46939-2",
    "data-name": "Group 46939-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_46938-2",
    "data-name": "Group 46938-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Path_56194-2",
    "data-name": "Path 56194-2",
    className: "customisable-product_svg__cls-8",
    d: "M37 31.82h19v15H37z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-8)",
    id: "customisable-product_svg__Group_47139-2",
    "data-name": "Group 47139-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_47138-2",
    "data-name": "Group 47138-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_47137-2",
    "data-name": "Group 47137-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Path_56414-2",
    "data-name": "Path 56414-2",
    className: "customisable-product_svg__cls-11",
    d: "M7.46 29.45h51.19c.46 0 .83 1.26.83 2.82v14.11c0 1.55-.37 2.82-.83 2.82H7.46c-.46 0-.83-1.26-.83-2.82V32.27c0-1.56.37-2.82.83-2.82z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_68052",
    "data-name": "Group 68052"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-10)",
    id: "customisable-product_svg__Group_46939-3",
    "data-name": "Group 46939-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_46938-3",
    "data-name": "Group 46938-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Path_56194-3",
    "data-name": "Path 56194-3",
    className: "customisable-product_svg__cls-8",
    d: "M97 5.82h19v15H97z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-12)",
    id: "customisable-product_svg__Group_47139-3",
    "data-name": "Group 47139-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_47138-3",
    "data-name": "Group 47138-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_47137-3",
    "data-name": "Group 47137-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Path_56414-3",
    "data-name": "Path 56414-3",
    className: "customisable-product_svg__cls-11",
    d: "M67.46 3.45h51.19c.46 0 .83 1.26.83 2.82v14.11c0 1.55-.37 2.82-.83 2.82H67.46c-.46 0-.83-1.26-.83-2.82V6.27c0-1.56.37-2.82.83-2.82z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_68055",
    "data-name": "Group 68055"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-14)",
    id: "customisable-product_svg__Group_46939-4",
    "data-name": "Group 46939-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_46938-4",
    "data-name": "Group 46938-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Path_56194-4",
    "data-name": "Path 56194-4",
    className: "customisable-product_svg__cls-8",
    d: "M97 31.82h19v15H97z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-16)",
    id: "customisable-product_svg__Group_47139-4",
    "data-name": "Group 47139-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_47138-4",
    "data-name": "Group 47138-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_47137-4",
    "data-name": "Group 47137-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Path_56414-4",
    "data-name": "Path 56414-4",
    className: "customisable-product_svg__cls-11",
    d: "M67.46 29.45h51.19c.46 0 .83 1.26.83 2.82v14.11c0 1.55-.37 2.82-.83 2.82H67.46c-.46 0-.83-1.26-.83-2.82V32.27c0-1.56.37-2.82.83-2.82z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_68053",
    "data-name": "Group 68053"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-18)",
    id: "customisable-product_svg__Group_46939-5",
    "data-name": "Group 46939-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_46938-5",
    "data-name": "Group 46938-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Path_56194-5",
    "data-name": "Path 56194-5",
    className: "customisable-product_svg__cls-8",
    d: "M157 5.82h19v15h-19z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-20)",
    id: "customisable-product_svg__Group_47139-5",
    "data-name": "Group 47139-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_47138-5",
    "data-name": "Group 47138-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_47137-5",
    "data-name": "Group 47137-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Path_56414-5",
    "data-name": "Path 56414-5",
    className: "customisable-product_svg__cls-11",
    d: "M127.46 3.45h51.19c.46 0 .83 1.26.83 2.82v14.11c0 1.55-.37 2.82-.83 2.82h-51.19c-.46 0-.83-1.26-.83-2.82V6.27c0-1.56.37-2.82.83-2.82z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_68056",
    "data-name": "Group 68056"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-22)",
    id: "customisable-product_svg__Group_46939-6",
    "data-name": "Group 46939-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_46938-6",
    "data-name": "Group 46938-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Path_56194-6",
    "data-name": "Path 56194-6",
    className: "customisable-product_svg__cls-8",
    d: "M157 31.82h19v15h-19z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customisable-product_svg__clip-path-24)",
    id: "customisable-product_svg__Group_47139-6",
    "data-name": "Group 47139-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_47138-6",
    "data-name": "Group 47138-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Group_47137-6",
    "data-name": "Group 47137-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Path_56414-6",
    "data-name": "Path 56414-6",
    className: "customisable-product_svg__cls-11",
    d: "M127.46 29.45h51.19c.46 0 .83 1.26.83 2.82v14.11c0 1.55-.37 2.82-.83 2.82h-51.19c-.46 0-.83-1.26-.83-2.82V32.27c0-1.56.37-2.82.83-2.82z"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Line_255",
    "data-name": "Line 255",
    className: "customisable-product_svg__cls-32",
    d: "M73.13 12.95h27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Line_257",
    "data-name": "Line 257",
    className: "customisable-product_svg__cls-32",
    d: "M73.13 38.95h27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Line_256",
    "data-name": "Line 256",
    className: "customisable-product_svg__cls-32",
    d: "M134.13 12.95h27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "customisable-product_svg__Line_258",
    "data-name": "Line 258",
    className: "customisable-product_svg__cls-32",
    d: "M134.13 38.95h27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Item_1",
    "data-name": "Item 1",
    className: "customisable-product_svg__cls-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "customisable-product_svg__cls-33",
    transform: "translate(12.63 16.45)"
  }, "Item 1")), /*#__PURE__*/React.createElement("g", {
    id: "customisable-product_svg__Item_2",
    "data-name": "Item 2",
    className: "customisable-product_svg__cls-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "customisable-product_svg__cls-33",
    transform: "translate(12.63 42.45)"
  }, "Item 2"))))));
}
export default SvgCustomisableProduct;